/* HIBA GLOBAL MOBILE GALLERY AUTO-HEIGHT v1
   Adapts the mobile hero to the CURRENT visible slide, preserving full portrait shots.
   All variants and fabrics; no filename or SKU assumptions; mobile only. */
(function () {
  "use strict";
  if (window.__hibaMobileGalleryAutoHeightV1) return;
  window.__hibaMobileGalleryAutoHeightV1 = true;

  var mq = window.matchMedia && window.matchMedia("(max-width: 749px)");
  if (!mq) return;

  var gallery = null;
  var wrapper = null;
  var mutationObserver = null;
  var activeImageObserver = null;
  var observedImage = null;
  var pendingFrame = 0;

  function releaseHeight() {
    if (gallery) {
      gallery.style.removeProperty("height");
      gallery.style.removeProperty("align-items");
    }
    if (wrapper) wrapper.style.removeProperty("height");
  }

  function visibleSlides(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll("[data-hiba-mobile-hero-slide]"),
      function (slide) {
        return !slide.classList.contains("hiba-mobile-hero-hidden") &&
          window.getComputedStyle(slide).display !== "none";
      }
    );
  }

  function focusedSlide(container, slides) {
    var midpoint = container.scrollLeft + container.clientWidth / 2;
    var closest = slides[0];
    var closestDistance = Infinity;

    slides.forEach(function (slide) {
      var center = slide.offsetLeft + slide.offsetWidth / 2;
      var distance = Math.abs(midpoint - center);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = slide;
      }
    });
    return closest;
  }

  function slideHeight(slide, container) {
    var img = slide && slide.querySelector("img.hiba-mobile-hero-gallery__image, img");
    if (!img) return { height: 0, image: null };

    var rect = img.getBoundingClientRect();
    var height = rect.height;

    if (!height || height < 2) {
      var w = img.naturalWidth || Number(img.getAttribute("width")) || 0;
      var h = img.naturalHeight || Number(img.getAttribute("height")) || 0;
      if (w > 0 && h > 0) {
        height = (rect.width || container.clientWidth) * h / w;
      }
    }

    return { height: Math.ceil(height), image: img };
  }

  function observeCurrentImage(img) {
    if (!window.ResizeObserver || img === observedImage) return;
    if (!activeImageObserver) {
      activeImageObserver = new ResizeObserver(function () { requestUpdate(); });
    }
    if (observedImage) activeImageObserver.unobserve(observedImage);
    observedImage = img;
    if (img) activeImageObserver.observe(img);
  }

  function update() {
    pendingFrame = 0;
    if (!mq.matches) {
      releaseHeight();
      return;
    }

    var candidate = document.querySelector("[data-hiba-mobile-hero-gallery]");
    var candidateWrapper = document.querySelector("[data-hiba-mobile-hero-gallery-wrap]");
    if (!candidate || !candidateWrapper || !document.body.classList.contains("hiba-mobile-hero-gallery-ready")) return;

    if (candidate !== gallery) bind(candidate, candidateWrapper);

    var slides = visibleSlides(gallery);
    if (!slides.length || !gallery.clientWidth) return;

    // Without this, flexbox stretches short slides to the tallest portrait photo.
    gallery.style.setProperty("align-items", "flex-start", "important");

    var current = focusedSlide(gallery, slides);
    var measured = slideHeight(current, gallery);
    if (!(measured.height > 0)) return;

    observeCurrentImage(measured.image);
    var h = measured.height + "px";
    if (gallery.style.height !== h) gallery.style.setProperty("height", h, "important");
    if (wrapper.style.height !== h) wrapper.style.setProperty("height", h, "important");
  }

  function requestUpdate() {
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(update);
  }

  function bind(nextGallery, nextWrapper) {
    if (mutationObserver) mutationObserver.disconnect();
    if (gallery) {
      gallery.removeEventListener("scroll", requestUpdate);
      gallery.removeEventListener("load", requestUpdate, true);
    }
    gallery = nextGallery;
    wrapper = nextWrapper;
    gallery.addEventListener("scroll", requestUpdate, { passive: true });
    gallery.addEventListener("load", requestUpdate, true);
    mutationObserver = new MutationObserver(requestUpdate);
    mutationObserver.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "src", "srcset"]
    });
  }

  function afterSelection() {
    requestUpdate();
    window.setTimeout(requestUpdate, 100);
    window.setTimeout(requestUpdate, 350);
  }

  ["variant:change", "product:variant-change", "hiba:variant-id-change",
   "hiba:gallery-range-request", "shopify:section:load"].forEach(function (name) {
    document.addEventListener(name, afterSelection);
  });
  window.addEventListener("resize", afterSelection, { passive: true });
  window.addEventListener("orientationchange", afterSelection, { passive: true });
  window.addEventListener("pageshow", afterSelection);

  // Shopify may hydrate and relocate the custom hero after initial page load.
  [0, 100, 300, 700, 1300, 2400].forEach(function (delay) {
    window.setTimeout(requestUpdate, delay);
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", afterSelection, { once: true });
  } else {
    afterSelection();
  }
})();
